import React, { useState, useEffect } from 'react';
import './HeroSlider.css';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: `${process.env.PUBLIC_URL}/images/building1.jpeg`,
      alt: 'Pragati Vidyalaya School'
    },
    {
      image: `${process.env.PUBLIC_URL}/images/building2.jpeg`,
      alt: 'Pragati Vidyalaya Campus'
    },
    {
      image: `${process.env.PUBLIC_URL}/images/building3.jpeg`,
      alt: 'Pragati Vidyalaya Building'
    },
    {
      image: `${process.env.PUBLIC_URL}/images/building4.jpeg`,
      alt: 'Pragati Vidyalaya Building'
    }
  ];

  // Handle image loading errors
  const handleImageError = (e, index) => {
    // Fallback to placeholder if local image fails
    e.target.src = `https://via.placeholder.com/1200x500?text=Pragati+Vidyalaya+Slide+${index + 1}`;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <div className="hero-slider">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img 
              src={slide.image} 
              alt={slide.alt}
              onError={(e) => handleImageError(e, index)}
              loading="lazy"
            />
          </div>
        ))}
        <button className="slider-btn prev" onClick={goToPrevious}>
          ❮
        </button>
        <button className="slider-btn next" onClick={goToNext}>
          ❯
        </button>
        <div className="slider-dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;

